var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (embed, locale, title, url) {
      pug_html = pug_html + "\u003Cdiv class=\"popup popup--require-login\"\u003E\u003Cdiv class=\"popup__header\"\u003E\u003Cdiv class=\"popup__title\"\u003E" + (pug.escape(null == (pug_interp = title) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"popup__close\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"popup__content popup__content--require-login\"\u003E\u003Cp\u003E" + (pug.escape(null == (pug_interp = locale.require_login.content) ? "" : pug_interp)) + "\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"popup__footer\"\u003E";
if (embed) {
pug_html = pug_html + "\u003Ca" + (" class=\"popup--require-login__button\""+pug.attr("href", url, true, true)+" target=\"_top\"") + "\u003E" + (pug.escape(null == (pug_interp = locale.require_login.title) ? "" : pug_interp)) + "\u003C\u002Fa\u003E";
}
else {
pug_html = pug_html + "\u003Ca" + (" class=\"popup--require-login__button\""+pug.attr("href", url, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = locale.require_login.title) ? "" : pug_interp)) + "\u003C\u002Fa\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }.call(this, "embed" in locals_for_with ?
        locals_for_with.embed :
        typeof embed !== 'undefined' ? embed : undefined, "locale" in locals_for_with ?
        locals_for_with.locale :
        typeof locale !== 'undefined' ? locale : undefined, "title" in locals_for_with ?
        locals_for_with.title :
        typeof title !== 'undefined' ? title : undefined, "url" in locals_for_with ?
        locals_for_with.url :
        typeof url !== 'undefined' ? url : undefined));
    ;;return pug_html;};
module.exports = template;